import React, { useState, useEffect, Component } from 'react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import { AgGridReact } from 'ag-grid-react';
import "../pagination/pagination.css"
import { IoAddSharp } from "react-icons/io5";
import Pagination from '../pagination/pagination';
import Select from 'react-select';
import { RiRefreshLine } from "react-icons/ri";
import { FaFileCircleExclamation } from "react-icons/fa6";
import LeaseApiService from '../../services/apiService';
import './style.css'
import moment from 'moment';
import WindowedSelect from 'react-windowed-select';
import LeaseTermination from './leaseTermination';
import CheckboxSetFilter from '../gridFilter/checkboxSetFilter';
import { useTranslation } from 'react-i18next';


const REACT_APP_REPORTS = process.env.REACT_APP_REPORTS_URL
const TerminationListing = () => {
    const { t } = useTranslation(['leaseTermination', 'common']);
    const [rowData, setRowData] = useState([])
    const [proprtyList, setProperty] = useState([])
    const [loading, setLoading] = useState(true)
    const [pageSize, setPageSize] = useState(20)
    const [pagination, setPagination] = useState()
    const [unitList, setUnitList] = useState([])
    const [leaseList, setLeaseList] = useState([])
    const apiService = new LeaseApiService()
    const [FilterTab, setFilterTab] = useState(true)
    const [permissions, setPermissions] = useState([])
    const [contextMenu, setContextMenu] = useState(null)
    const [showAddModal, setShowAddModal] = useState(false)

    const [formData, setFormData] = useState({
        Proprty: [{ label: 'Select Property', value: '' }],
        unitNo: [{ label: 'Select Unit No', value: '' }],
        leaseNo: [{ label: 'Select Lease No', value: '' }],
    })
    useEffect(() => {
        const handleClickOutside = () => setContextMenu(null);
        window.addEventListener('click', handleClickOutside);
        return () => window.removeEventListener('click', handleClickOutside);
    }, [])
    useEffect(() => {
        const storedPermissions = JSON.parse(localStorage.getItem('RoleAccess')) || [];
        const permissions = storedPermissions?.filter(acc => acc.formName === "Lease Reservation");
        setPermissions(permissions[0]);
    }, [])
    useEffect(() => {
        getItems();
        fetchDropdownData();
    }, [])
    const fetchDropdownData = async () => {
        try {
            const params = new URLSearchParams();
            params.append('dropdownTypes', 'TerminationSearchPropertyNames,TerminationSearchLeaseNos');
            const res = await apiService.getApiParamater('TERMINATION_MULTI', `?${params.toString()}`);
            setProperty([{ value: 'All', text: 'All' }, ...res?.data?.dropdowns?.PropertyNames]);
            setLeaseList([{ value: 'All', text: 'All' }, ...res?.data?.dropdowns?.SearchLeaseNos]);
        } catch (error) {
            console.error('Error fetching dropdown data:', error);
        }
    }
    const handlePrint = (rowData) => {
        if (rowData) {
            const token = localStorage.getItem("Token");
            const DB = localStorage.getItem("DataBase");
            if (!token) {
                alert("Auth token is missing! Unable to proceed.");
                return;
            }

            // Open both reports simultaneously
            const popupWidth = 1000;
            const popupHeight = 600;
            const popupLeft = (window.screen.width - popupWidth) / 2;
            const popupTop = (window.screen.height - popupHeight) / 2;
            const popup = window.open(
                "",
                "ReportPopup",
                `width=${popupWidth},height=${popupHeight},left=${popupLeft},top=${popupTop},resizable=yes,scrollbars=yes`
            );

            if (popup) {
                const form = document.createElement("form");
                form.method = "POST";
                form.action = REACT_APP_REPORTS;
                form.target = "ReportPopup";
                const inputs = [
                    { name: "authToken", value: token },
                    { name: "_db", value: DB },
                    { name: "LeaseNo", value: rowData?.lease_No },
                    { name: "reportName", value: "LTER" },
                ];
                inputs.forEach(({ name, value }) => {
                    const input = document.createElement("input");
                    input.type = "hidden";
                    input.name = name;
                    input.value = value;
                    form.appendChild(input);
                });
                document.body.appendChild(form);
                form.submit();
                document.body.removeChild(form);
            }
        }
    }
    const getItems = async (newPageNo = pagination?.currentPage) => {
        try {
            const params = new URLSearchParams();
            params.append('PageNo', newPageNo || 1);
            params.append('PageSize', 50);
            params.append('PropertyNo', formData?.Proprty?.value?.value || 'All');
            params.append('UnitNo', formData?.unitNo?.label || 'All');
            params.append('Leaseno', formData?.leaseNo?.label || 'All');
            const res = await apiService.getApiParamater('GET_LEASE_TERMINATION', `?${params.toString()}`);
            setRowData(res?.data?.result || []);
            setPagination(res.data.paginationData);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching items:', error);
            setLoading(false);
        }
    }
    const SearchItems = async (newPageNo = pagination?.currentPage) => {
        try {
            const params = new URLSearchParams();
            params.append('PageNo', 1);
            params.append('PageSize', 50);
            params.append('PropertyNo', formData?.Proprty?.value?.value || 'All');
            params.append('UnitNo', formData?.unitNo?.label || 'All');
            params.append('Leaseno', formData?.leaseNo?.label || 'All');
            const res = await apiService.getApiParamater('GET_LEASE_TERMINATION', `?${params.toString()}`);
            setRowData(res?.data?.result || []);
            setPagination(res.data.paginationData);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching items:', error);
            setLoading(false);
        }
    }
    const numberValueFormatter = function (params) {
        return params?.value;
    }
    const dateFormatter = (params) => {
        const date = moment(params.value);
        return date.format("DD-MMM-YYYY");
    }
    const dateComparator = (date1, date2) => {
        const momentDate1 = moment(date1);
        const momentDate2 = moment(date2);
        return momentDate1.isSame(momentDate2) ? 0 : momentDate1.isBefore(momentDate2) ? -1 : 1;
    }
    const columnDefs = [
        {
            headerName: '', field: 'recordId', cellRenderer: BtnCellRenderer, pinned: 'left',
            cellRendererParams: {
                clicked: function (field, exp2) {
                    handleMenuAction(field, exp2);
                },
            }, width: 30,
        },
        {
            headerName: t('leaseTermination:columns.leaseNo'), field: 'lease_No', filter: CheckboxSetFilter,
            valueFormatter: numberValueFormatter, suppressMovable: true, width: 150, pinned: 'left'
        }, {
            headerName: t('leaseTermination:columns.leaseFrom'), field: 'lease_Date', filter: CheckboxSetFilter,
            valueFormatter: dateFormatter,
            comparator: dateComparator, suppressMovable: true, width: 130,
        },
        {
            headerName: t('leaseTermination:columns.leaseTo'), field: 'lease_Expiry', filter: CheckboxSetFilter,
            valueFormatter: dateFormatter,
            comparator: dateComparator,suppressMovable: true, width: 130,
        },
        {
            headerName: t('leaseTermination:columns.vacatingDate'), field: "vacatingDate", filter: CheckboxSetFilter,
            valueFormatter: dateFormatter,
            comparator: dateComparator, suppressMovable: true, width: 136
        },
        {
            headerName: t('leaseTermination:columns.totalPrice'), field: 'totalPrice',
            valueFormatter: numberValueFormatter, filter: CheckboxSetFilter, suppressMovable: true, width: 150
        },
        {
            headerName: t('leaseTermination:columns.propertyName'), field: 'property_Name', filter: CheckboxSetFilter,
            valueFormatter: numberValueFormatter, suppressMovable: true, width: 250
        },
        {
            headerName: t('leaseTermination:columns.unitNo'), field: 'unit_No', filter: CheckboxSetFilter,
            valueFormatter: numberValueFormatter, suppressMovable: true, width: 130
        },
        {
            headerName: t('leaseTermination:columns.tenantName'), field: 'cust1_Name', filter: CheckboxSetFilter,
            valueFormatter: numberValueFormatter, suppressMovable: true, width: 200
        },
        {
            headerName: t('leaseTermination:columns.agent'), field: 'agent', filter: CheckboxSetFilter,
            valueFormatter: numberValueFormatter, suppressMovable: true, width: 250
        },
        {
            headerName: t('leaseTermination:columns.salesPerson'), field: 'salesPerson',
            valueFormatter: numberValueFormatter, filter: CheckboxSetFilter, suppressMovable: true, width: 200
        },
        {
            headerName: t('leaseTermination:columns.reason'), field: 'reason',
            valueFormatter: numberValueFormatter, filter: CheckboxSetFilter, suppressMovable: true, width: 250
        },
    ]
    const handlenew = () => {
        setShowAddModal(true)
    }
    const handleClearFilters = () => {
        setFormData({
            Proprty: [{ label: 'Select Property', value: '' }],
            unitNo: [{ label: 'Select Unit No', value: '' }],
            TanantName: [{ label: 'Select Tenant', value: '' }],
            leaseNo: [{ label: 'Select Lease No', value: '' }],
        });
        fetchDropdownData()
    }
    const handlePropertyChange = async (selectedOption) => {
        if (selectedOption?.label === "All") {
            setFormData({
                ...formData,
                Proprty: selectedOption,
                unitNo: [{ label: '', value: '' }]
            });
        } else {
            const params = new URLSearchParams();
            params.append('DropdownFor', 'TeminationSearchUnitNosByPropertyId');
            params.append('CascadValue', selectedOption?.value?.value);
            const res = await apiService.getApiParamater('TERMINATION_CASCAD', `?${params.toString()}`);
            if (res?.data?.statusCode === 204) {
                setUnitList(res?.data?.items);
                setFormData({
                    ...formData,
                    Proprty: selectedOption,
                    unitNo: [{ label: '', value: '' }]
                });
            } else {
                setUnitList([{ value: 'All', text: 'All' }, ...res?.data?.items]);
                setFormData({
                    ...formData,
                    Proprty: selectedOption,
                    unitNo: [{ label: '', value: '' }]
                });
            }
        }

    }
    const handleUitNo = async (selectedOption) => {
        if (selectedOption?.value?.value === "All") {
            setFormData({
                ...formData,
                unitNo: selectedOption,
                leaseNo: [{ label: '', value: '' }]
            });
        } else {
            let selectedLease = leaseList.find((comp) => comp.value === selectedOption?.value?.value)
            setFormData({
                ...formData,
                unitNo: selectedOption,
                leaseNo: { label: selectedLease?.value, value: selectedLease },
            });
        }
    }
    const handleLeaseChange = (selectedOption) => {
        setFormData({ ...formData, leaseNo: selectedOption });
    }
    const handleMenuAction = (action, rowData) => {
        if (action === 'print') {
            handlePrint(rowData);
        }
        setContextMenu(null); // Close the menu
    }

    return (
        <div className='p-3 '>
            <div className="cost-center-section">
                <div className="d-flex  cursor-pointer slide-header"
                    onClick={() => setFilterTab(!FilterTab)}>
                    <div className='h6 pt-1'>{t('common:searchParameters')}</div>
                </div>
                <div className={`slide-content ${FilterTab ? 'open' : 'closed'}`}>
                    <div className={`border-box2 p-3 ${FilterTab ? 'slide-in' : 'slide-out'}`}>
                        <div className='filter-grid'>
                            <div className='filter-grid-fields'>
                                <div className='filter-grid-field'>
                                    <label>{t('common:property')}</label>
                                    <Select
                                        theme={(theme) => ({
                                            ...theme,
                                            borderRadius: 5,
                                            padding: 9
                                        })}

                                        menuPortalTarget={document.body}
                                        menuPlacement="auto"
                                        menuShouldScrollIntoView={false}
                                        styles={{
                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                            option: (provided, state) => ({
                                                ...provided,
                                                backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                color: state.isFocused ? '#000 ' : '#000',
                                                ':hover': {
                                                    backgroundColor: '#F5F5F5',
                                                    color: '#000 ',
                                                },
                                            }),
                                        }}
                                        value={formData.Proprty}
                                        onChange={(selectedOption) => handlePropertyChange(selectedOption)}
                                        options={proprtyList?.map((rec) => ({ value: rec, label: rec?.text }))}
                                    />
                                </div>
                                <div className='filter-grid-field'>
                                    <label>{t('common:unitNo')}</label>
                                    <Select
                                        theme={(theme) => ({
                                            ...theme,
                                            borderRadius: 5,
                                            padding: 9
                                        })}

                                        menuPortalTarget={document.body}
                                        menuPlacement="auto"
                                        menuShouldScrollIntoView={false}
                                        styles={{
                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                            option: (provided, state) => ({
                                                ...provided,
                                                backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                color: state.isFocused ? '#000 ' : '#000',
                                                ':hover': {
                                                    backgroundColor: '#F5F5F5',
                                                    color: '#000 ',
                                                },
                                            }),
                                        }}
                                        value={formData.unitNo}
                                        onChange={(selectedOption) => handleUitNo(selectedOption)}
                                        options={unitList?.map((rec) => ({ value: rec, label: rec?.text }))}
                                    />
                                </div>
                                <div className='filter-grid-field'>
                                    <label>{t('common:leaseNo')}</label>
                                    <WindowedSelect
                                        theme={(theme) => ({
                                            ...theme,
                                            borderRadius: 5,
                                            padding: 9
                                        })}

                                        menuPortalTarget={document.body}
                                        menuPlacement="auto"
                                        menuShouldScrollIntoView={false}
                                        styles={{
                                            menuPortal: base => ({ ...base, zIndex: 9999 }),
                                            option: (provided, state) => ({
                                                ...provided,
                                                backgroundColor: state.isFocused ? '#F5F5F5' : null,
                                                color: '#000',
                                                ':hover': {
                                                    backgroundColor: '#F5F5F5',

                                                    color: '#000',
                                                },
                                            }),
                                        }}
                                        options={
                                            leaseList
                                                ?.slice(0, 5000)
                                                .map(rec => ({ value: rec, label: rec?.value }))
                                        }
                                        value={formData.leaseNo}
                                        onChange={(selectedOption) => handleLeaseChange(selectedOption)}
                                    />
                                </div>
                            </div>
                            <div className='filter-grid-actions'>
                                <div
                                    onClick={() => SearchItems()}
                                    className='mainbtnGry flex-end gap-2'>
                                    <FaFileCircleExclamation color='#fff' className='center mt-1 mx-2' />
                                    <div className='center'>{t('common:search')}</div>
                                </div>
                                <div
                                    onClick={() => handleClearFilters()}
                                    className='mainbtnRed flex-end gap-2'>
                                    <RiRefreshLine color='#fff' className='center mt-1 mx-2' />
                                    <div className='center'>{t('common:reset')}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='border-box2 p-4'>
                {loading ? (
                    <div>{t('common:loading')}</div>
                ) : (
                    <>
                        <div className='d-flex justify-contant-between '>
                            <h5 className='col mainInvHead'>{t('leaseTermination:listTitle')}</h5>
                            <div className='d-flex justify-content-end gap-1'>
                                {/* {permissions?.canAdd === true ? */}
                                <div className='col center'>
                                    <button className='mainbtn ' type="submit" onClick={() => handlenew()}>
                                        <IoAddSharp color='#fff' className='center mt-1' /> <div>{t('common:add')}</div>
                                    </button>
                                </div>
                                {/* </div> : "" */}
                                {/* } */}
                            </div>
                        </div>
                        <div className='gridshad  mt-3'>
                            <div className="ag-theme-quartz" style={{ height: 650 }}>
                                <AgGridReact
                                    getRowStyle={(params) => {
                                        if (params.node.rowIndex % 2 === 0) {
                                            return { background: '#F0EDF5' };
                                        } else {
                                            return { background: '#fff' };
                                        }
                                    }}
                                    rowData={rowData}
                                    enableFilter={true}
                                    columnDefs={columnDefs}
                                    frameworkComponents={{ BtnCellRenderer }}
                                    context={{ setContextMenu }}
                                />
                            </div>
                            <Pagination pageSize={pageSize} setPageSize={setPageSize} pagination={pagination} getItems={getItems} />
                        </div>
                    </>
                )}
            </div>
            {contextMenu && (
                <div
                    style={{
                        position: 'absolute',
                        top: contextMenu.mouseY,
                        left: contextMenu.mouseX,
                        backgroundColor: 'white',
                        border: '1px solid gray',
                        zIndex: 1000,
                        padding: '10px 30px',
                        borderRadius: '8px',
                        boxShadow: '0px 2px 6px rgba(0,0,0,0.2)'
                    }}
                >
                    <div style={{ display: 'grid' }}>
                        <button className="btn btn-secondary mt-2" onClick={() => handleMenuAction('print', contextMenu.data)}>
                            {t('leaseTermination:print')}
                        </button>
                    </div>
                </div>
            )}
            {showAddModal && (
                <LeaseTermination
                    show={showAddModal}
                    onClose={() => setShowAddModal(false)}
                    onSaved={() => {
                        setShowAddModal(false);
                        getItems();
                    }}
                />
            )}
        </div>
    )
}
class BtnCellRenderer extends Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(e) {
        e.stopPropagation(); // Prevent row selection
        const { context, data } = this.props;

        if (context && context.setContextMenu) {
            context.setContextMenu({
                mouseX: e.clientX,
                mouseY: e.clientY,
                data: data
            });
        }
    }

    render() {
        return (
            <div className='center'>
                <span onClick={this.handleClick} style={{ cursor: 'pointer', fontSize: '30px' }}>
                    &#8942; {/* Vertical Ellipsis */}
                </span>
            </div>
        );
    }
}

export default TerminationListing;